/**
 * Returns the initial (first) item in the input array
 */
const initial = (arr: any[]) => arr[0];
export default initial;
